const fallbackError = 'Something went wrong';

export const errorEntryMessage = e => e.errorDescription || e.message;

export default errorInfo => {
  if (!errorInfo.details || !errorInfo.details.errors) {
    return [fallbackError];
  } else {
    return errorInfo.details.errors.map(e => errorEntryMessage(e) || fallbackError);
  }
};
